import styled from "styled-components";

export const Wrapper = styled.div`
    .title {
        font-size: 18px;
        padding: 5px;

        @media screen and (max-width: 992px) {
            font-size: 14px;
        }
    }

    .button-box .button-el {
        width: 100%;
        padding: 10px;
        border: 1px solid #e1e1e1;
        background-color: white;
        box-shadow: var(--defaultBoxShadow);
        font-size: 16px;
        border-radius: 10px;
        transition: 0.15s;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        cursor: pointer;

        @media screen and (max-width: 992px) {
            font-size: 12px;
        }

        &:hover {
            background-color: #f4f4f4;
        }
    }

    .button-el .button-inner-text {
        display: flex;
        align-items: center;
        gap: 5px;
    }
`;